// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"ea4c59cbcf","253":"b7403ebd4d","619":"201ff7513a"}[chunkId] + ".js";
};